import { render, staticRenderFns } from "./MyBookingsListPage.vue?vue&type=template&id=58ea30f4&scoped=true&"
import script from "./MyBookingsListPage.vue?vue&type=script&lang=ts&"
export * from "./MyBookingsListPage.vue?vue&type=script&lang=ts&"
import style0 from "./MyBookingsListPage.vue?vue&type=style&index=0&id=58ea30f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ea30f4",
  null
  
)

export default component.exports